// extracted by mini-css-extract-plugin
module.exports = {"footer":"EditNftModal_footer__3wZds","label":"EditNftModal_label__12mX-"};